import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AlertDetailsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AlertDetailsPage";
import { getAlertDetailsAccountWidgetConfig } from "components/pages/AlertDetailsPage/components/AlertDetailsAccountWidget";
import Classes, { Account, NotificationDetail } from "model";
import { useEffect } from "react";

export default function CaptureNotifiAccountAdded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    let data = getDefaultPageData("1");
    const details = data.notificationDetails.map(info => {
        info.isEnabled = "false";
        info.amount = 0;

        if(hasConsumerAccounts) {
            if(info.id === "0") {
                info.amount = 100;
                info.isEnabled = "true";
                NotificationDetail.update(info).submit(Classes);
            }
        } else {
            if(info.id === "7") {
                info.amount = 100;
                info.isEnabled = "true";
                NotificationDetail.update(info).submit(Classes);
            }
        }

        return info;
    }, []);

    data = BCMSStateManagerCRUD.init(data)
    .update([ "notificationDetails" ], details)
    .submit();

    const widgetConfig = getAlertDetailsAccountWidgetConfig();
    widgetConfig.action = "added";

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ hasConsumerAccounts ? "Detail_0" : "Detail_7" ], widgetConfig)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AlertDetailsPage data={ data } ui={ ui } />
}